import * as React from 'react';
import { ITab, mergeStyles } from '@cian/components';
import { PikTabGroup } from '../../ui/pik_tab_group/pik_tab_group';
import { facts, history, main } from './data';
import { connect } from 'react-redux';
import { IApplicationState } from '../../types/redux';
import { PlainLocationDescriptor } from '../../utils/location';
import { changeTabs } from '../../actions/location';
import { TComponentWithTabsProps } from '../../types/tabs';
import { VideoPlayer } from '../video-player';

import * as styles from './about.css';

export type AboutTabId = 'main' | 'facts' | 'history' | 'video';

interface IInjectedProps extends TComponentWithTabsProps {
  location: PlainLocationDescriptor;
}

export class AboutComponent extends React.PureComponent<IInjectedProps, object> {
  private tabs: ITab[] = [
    { id: 'main', title: 'Главное' },
    { id: 'facts', title: 'Факты' },
    { id: 'history', title: 'История' },
    { id: 'video', title: 'Видео' },
  ];

  public render() {
    const { about: activeTab } = this.props.tabs;

    return (
      <div className={styles['about']}>
        <PikTabGroup activeTab={activeTab} onTabClick={this.handleTabToggle} tabs={this.tabs} />

        <div className={styles['tabs-content']}>{this.renderTabsPage(activeTab)}</div>
      </div>
    );
  }

  private handleTabToggle = (value: AboutTabId) =>
    this.props.changeTabs({
      ...this.props.tabs,
      about: value,
    });

  private renderTabsPage = (tab: AboutTabId): React.ReactNode => {
    const tabs: { [key: string]: React.ReactNode } = {
      facts: (
        <div {...mergeStyles(styles['list'], styles['fact-list'])}>
          {facts.map((factGroup, groupIndex) => (
            <div className={styles['fact-group']} key={groupIndex}>
              {factGroup.map((fact, index) => (
                <div className={styles['fact']} key={index}>
                  {fact.icon && <fact.icon iconClassName={styles['fact-icon']} />}
                  {fact.title && <div className={styles['fact-title']}>{fact.title}</div>}
                  {fact.text && <span className={styles['fact-text']}>{fact.text}</span>}
                </div>
              ))}
            </div>
          ))}
          <div className={styles['fact-comment']}>Входит в перечень системообразующих предприятий России</div>
        </div>
      ),
      history: (
        <ul {...mergeStyles(styles['list'], styles['history'])}>
          {history.map((fact, index) => (
            <li {...mergeStyles(styles['year'])} key={index}>
              <span className={styles['year-number']}>{fact.year}</span>
              <div className={`${styles['year-image']} ${styles[`year-${fact.year}`]}`} />
              <p className={styles['year-text']}>{fact.text}</p>
            </li>
          ))}
        </ul>
      ),
      main: (
        <div className={styles['main']}>
          <figure className={styles['logo']}>Кредитный рейтинг компании</figure>
          {main.map((info, index) => (
            <p className={styles['text']} key={index}>
              <strong>{info.strong}</strong> {info.text}
            </p>
          ))}
        </div>
      ),
      video: <VideoPlayer videoURL="gAKcwqqo_Qk" />,
    };

    return tabs[tab];
  };
}

export const About = connect(
  (state: IApplicationState) => ({
    tabs: state.tabs,
    location: state.location,
  }),
  {
    changeTabs,
  },
)(AboutComponent);
